import { render, staticRenderFns } from "./BusAssetStorageDetailModal__Style#Drawer.vue?vue&type=template&id=0254f35c&scoped=true&"
import script from "./BusAssetStorageDetailModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BusAssetStorageDetailModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BusAssetStorageDetailModal__Style#Drawer.vue?vue&type=style&index=0&id=0254f35c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254f35c",
  null
  
)

export default component.exports